var _rect, _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 130,
    viewBox: "0 0 322 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -16,
    width: 323,
    height: 154.839,
    rx: 23.6449,
    fill: "#F7F9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9494_62320)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.558,
    cy: -15.5814,
    rx: 114.51,
    ry: 105.039,
    fill: "#F4681D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9494_62320)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.153,
    cy: 139.326,
    rx: 96.7175,
    ry: 88.7184,
    fill: "#FF6161"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9494_62320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: -67,
    r: 103,
    fill: "#FFE1DA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: -26,
    r: 103,
    fill: "#FFC3B6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_9494_62320)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0636,
    cy: 100.757,
    rx: 114.51,
    ry: 105.039,
    fill: "#5783F1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_9494_62320)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.1736,
    cy: -40.6904,
    rx: 153.744,
    ry: 141.029,
    fill: "#FFD6D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9494_62320",
    x: 65.2768,
    y: -242.392,
    width: 472.562,
    height: 453.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_9494_62320"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9494_62320",
    x: 71.664,
    y: -71.1636,
    width: 436.977,
    height: 420.979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_9494_62320"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_9494_62320",
    x: -169.217,
    y: -126.054,
    width: 472.562,
    height: 453.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_9494_62320"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_9494_62320",
    x: -178.342,
    y: -303.49,
    width: 551.031,
    height: 525.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.8855,
    result: "effect1_foregroundBlur_9494_62320"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9494_62320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 77,
    fill: "white",
    transform: "translate(142)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBg);
export default __webpack_public_path__ + "static/media/red_bg.f4db686e9cb1a0bcdcb1d3f1143c5b16.svg";
export { ForwardRef as ReactComponent };